import Vue from 'vue'
import $api from '@/shared/services/api'
import autenticacao from '@/shared/services/autenticacao'

export default {
    namespaced: true,
    state: {
        dominio: null,
        dominioPortal: null,
    },
    getters: {
        pegaDominio(state){
            return state.dominio
        },
        pegaDominioPortal(state){
            return state.dominioPortal
        },
    },
    mutations: {
        atualizaDominio(state, dominio){
            state.dominio = dominio
        },
        atualizaDominioPortal(state, dominioPortal){
            state.dominioPortal = dominioPortal
        },
    },
    actions: {
        async carregaDominio({ commit }){
            const retorno = await $api.cGet('/dominios/dados')
            if(retorno.status == 'success'){
                commit('atualizaDominio', retorno.data.Dominio)
            }else{
                Vue.prototype.$dialog.error(retorno.message)
            }
        },
        // GCK-20829: identidade da LOJA do portal (logomarca, cores da Área do
        // Cliente e dados de divulgação), resolvida pelo host da requisição.
        // O host vai no header `http-origin` (o `host-origin` padrão do $api é
        // interceptado pelo valida_http global do white label). O x-token-auth
        // precisa ir junto: com sessão ativa o back resolve a identidade pela
        // LOJA do cliente logado quando o host não resolve (GCK-20830/QA) —
        // headers custom no $api.axios substituem os padrão. Sem loja
        // resolvida (tela de login em domínio genérico/dev), fica null e as
        // telas caem no white label do $app.
        async carregaDominioPortal({ commit, state }){
            if(state.dominioPortal){
                return state.dominioPortal
            }
            try{
                const retorno = await $api.axios('/area_cliente/sistema/dominio', null, 'get', undefined, {
                    'x-token-auth': autenticacao.pegaToken() || '',
                    'http-origin': window.location.host
                })
                if(retorno.status == 'success'){
                    commit('atualizaDominioPortal', retorno.data)
                }
                return retorno
            }catch(erro){
                return null
            }
        }
    },
}
